<template>
  <div
    class="goodsManageSet"
    :class="{ fixedStyle: isShowStyle }"
    :style="{ top: scrollTop + 'px' }"
  >
    <div class="banner">
      <img src="../../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon">
        <i class="iconfont icon-shangpinsku"></i>
      </div>
      <div class="breadcrumb_item">SKU管理</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">商品管理</div>
    </div>

    <div class="main_content">
      <van-tabs type="card" v-model="activeName" @click="handleClick">
        <van-tab title="关键词标签" name="first">
          <div class="form_container">
            <div class="check_box">
              <h1>勾选关键词标签（最多勾选3项）</h1>
              <!-- <van-checkbox-group
          v-model="labelType"
          direction="horizontal"
          @change="changeLabelType"
        >
          <van-checkbox name="068b731f32634ce6b92e7a3131268001"
            >全局</van-checkbox
          >
          <van-checkbox name="068b731f32634ce6b92e7a3131268002"
            >关联一级分类标签</van-checkbox
          >
          <van-checkbox name="068b731f32634ce6b92e7a3131268003"
            >关联二级分类标签</van-checkbox
          >
          <van-checkbox name="068b731f32634ce6b92e7a3131268004"
            >关联三级分类标签</van-checkbox
          >
        </van-checkbox-group> -->
            </div>
            <div class="content_wrap">
              <!-- <h1>选择关联分类标签详情</h1> -->
              <div class="check_box">
                <van-checkbox-group
                  v-model="check2"
                  direction="horizontal"
                  :max="3"
                >
                  <van-checkbox
                    v-for="item in leavellist"
                    :key="item.typeid"
                    :name="item.typeid"
                    >{{ item.typename }}</van-checkbox
                  >
                </van-checkbox-group>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="款式标签" name="second">
          <div class="form_container">
            <h1>勾选款式标签<span>（每一项最多勾选3项）</span></h1>
            <div class="content_wrap">
              <div class="content_block">
                <p>一级款式标签</p>
                <div class="check_box">
                  <van-checkbox-group
                    v-model="checkStyleOne"
                    direction="horizontal"
                    :max="3"
                  >
                    <van-checkbox
                      v-for="item in styleLabelOne"
                      :key="item.id"
                      :name="item.id"
                      >{{ item.labelcont }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
              </div>
              <div class="content_block">
                <p>二级款式标签</p>
                <div class="check_box">
                  <van-checkbox-group
                    v-model="checkStyleTwo"
                    direction="horizontal"
                    :max="3"
                  >
                    <van-checkbox
                      v-for="item in styleLabelTwo"
                      :key="item.id"
                      :name="item.id"
                      >{{ item.labelcont }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
              </div>
              <div class="content_block">
                <p>三级款式标签</p>
                <div class="check_box">
                  <van-checkbox-group
                    v-model="checkStyleThree"
                    direction="horizontal"
                    :max="3"
                  >
                    <van-checkbox
                      v-for="item in styleLabelThree"
                      :key="item.id"
                      :name="item.id"
                      >{{ item.labelcont }}</van-checkbox
                    >
                  </van-checkbox-group>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
        <van-tab title="功能标签" name="third">
          <div class="form_container">
            <h1>功能标签</h1>
            <div class="content_wrap">
              <div class="content_block">
                <p>一级功能标签</p>
                <div class="check_box">
                  <van-radio-group
                    v-model="formData.funcids_num1"
                    direction="horizontal"
                     @change="handleRadioFuncid"
                  >
                    <van-radio
                      v-for="item in cmLevel1"
                      :key="item.id"
                      :name="item.id"
                      >{{ item.labelcont }}</van-radio
                    >
                  </van-radio-group>
                </div>
              </div>
              <div class="content_block" v-if="cmLevel2.length > 0">
                <p>二级功能标签</p>
                <div class="check_box">
                  <van-radio-group
                    v-model="formData.funcids_num2"
                    direction="horizontal"
                    :max="3"
                  >
                    <van-radio
                      v-for="item in cmLevel2"
                      :key="item.id"
                      :name="item.id"
                      >{{ item.labelcont }}</van-radio
                    >
                  </van-radio-group>
                </div>
              </div>
            </div>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- <div class="main_content">
      <div class="tit">商品标签（关键词标签）设置</div>
      <div class="block">
        <h1><span class="mark">*</span>设置全局关键词标签（多选）</h1>
        <div class="check_box">
          <van-checkbox-group v-model="check1" direction="horizontal">
            <van-checkbox
              v-for="item in leavelOne"
              :key="item.id"
              :name="item.id"
              >{{ item.labelname }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>

      <div class="block">
        <h1>设置一级分类关联关键词标签</h1>
        <p >
          根据你为商品选择的一级分类，<br />
          选择一级关键词标签（多选）
        </p>
        <div class="check_box">
          <van-checkbox-group v-model="check2" direction="horizontal">
            <van-checkbox
              v-for="item in leavelTwo"
              :key="item.id"
              :name="item.id"
              >{{ item.labelname }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>

      <div class="block">
        <h1>设置二级分类关联关键词标签</h1>
        <p >
          根据你为商品选择的二级分类，<br />
          选择二级关键词标签（多选）
        </p>
        <div class="check_box">
          <van-checkbox-group v-model="check3" direction="horizontal">
            <van-checkbox
              v-for="item in leavelThree"
              :key="item.id"
              :name="item.id"
              >{{ item.labelname }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>

      <div class="block">
        <h1>设置三级分类关联关键词标签</h1>
        <p >
          根据你为商品选择的三级分类，<br />
          选择三级关键词标签（多选）
        </p>
        <div class="check_box">
          <van-checkbox-group v-model="check4" direction="horizontal">
            <van-checkbox
              v-for="item in leavelFour"
              :key="item.id"
              :name="item.id"
              >{{ item.labelname }}</van-checkbox
            >
          </van-checkbox-group>
        </div>
      </div>      
    </div> -->

    <div class="primary-button" @click="query">保存确认</div>
    <div class="primary-button return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i>返回
    </div>
  </div>
</template>

<script>
import {
  getCommidityDetail,
  editCommidity,
  getShopKeywordLabel,
  encryptstringview,
  getStyleLabelList,
  getShopFunList,
  getShopFunChildList,
} from "../../../api/api";
import { mapState } from "vuex";
export default {
  name: "cLabel",
  data() {
    return {
      radio: "",
      searchText: "",
      isShowStyle: false,
      scrollTop: 0,

      leavellist: [],
      labelType: [],

      leavelOne: [],
      leavelTwo: [],
      leavelThree: [],
      leavelFour: [],

      check1: [],
      check2: [],
      check3: [],
      check4: [],

      checkStyleOne: [],
      checkStyleTwo: [],
      checkStyleThree: [],

      formData: {
        Method: "ams_shop_commodity_edit",
        id: "",
        labels: "",
        styleids_num1: "",
        styleids_num2: "",
        styleids_num3: "",
         funcids_num1: '',    // 一级功能标签
        funcids_num2: '',  // 二级功能标签
        // labels2: "",
        // labels3: "",
        // labels4: "",
      },
      cmid: "",

      activeName: "first",
      styleLabelOne: [], // 一级款式标签
      styleLabelTwo: [], // 二级款式标签
      styleLabelThree: [], // 三级款式标签
      cmLevel1: [], // 商品一级功能列表
      cmLevel2: [], // 商品一级功能列表
    };
  },
  watch: {
    labelType(item1, item2) {
      let filter = item2.filter(function (v) {
        return item1.indexOf(v) == -1;
      });
      if (filter.length == 0) return;
      if (filter[0] == "068b731f32634ce6b92e7a3131268001") {
        this.check1 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268002") {
        this.check2 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268003") {
        this.check3 = [];
      }
      if (filter[0] == "068b731f32634ce6b92e7a3131268004") {
        this.check4 = [];
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList } = this.$store.state;
    let { name } = this.$route;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.cmid = id;
        this.getDetail();
      } else {
        this.$router.back();
      }
    },

    async getDetail() {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });

      let id = this.cmid;
      // 获取商品详情
      let shopDetail = await getCommidityDetail({ id });
      this.formData.id = shopDetail.id ? shopDetail.id : "";
      this.formData.labels = shopDetail.labels ? shopDetail.labels : "";

      // 获取关键字标签
      let labelList = await getShopKeywordLabel({
        labelids: shopDetail.labelid ? shopDetail.labelid : "",
      });
      this.leavellist = labelList;

      // 转换为整数数组
      let newArr = shopDetail.labels ? shopDetail.labels.split(",") : [];
      let intArray = newArr.map((value) => parseInt(value, 10));
      this.check2 = intArray;

      let newArr1 = shopDetail.styleids_num1
        ? shopDetail.styleids_num1.split(",")
        : [];
      this.checkStyleOne = newArr1.map((value) => parseInt(value, 10));

      let newArr2 = shopDetail.styleids_num2
        ? shopDetail.styleids_num2.split(",")
        : [];
      this.checkStyleTwo = newArr2.map((value) => parseInt(value, 10));

      let newArr3 = shopDetail.styleids_num3
        ? shopDetail.styleids_num3.split(",")
        : [];
      this.checkStyleThree = newArr3.map((value) => parseInt(value, 10));

      // 功能标签
      this.formData.funcids_num1 = shopDetail.funcids_num1 ? parseInt(shopDetail.funcids_num1) : ''
      this.formData.funcids_num2 = shopDetail.funcids_num2 ? parseInt(shopDetail.funcids_num2) : ''
      if(shopDetail.funcids_num1) {
        this.getShopFunChildList()
      }

      Toast.clear();
    },

    handleClick(tab) {
      this.activeName = tab;
      if (tab == "second") {
        this.getStyleLabelList();
      }else if(tab == "third") {
        this.getShopFunList()
      }
    },

    // 获取样式标签
    getStyleLabelList() {
      let params = {
        pageindex: 1,
        pagesize: 50,
        keyword: "",
      };
      getStyleLabelList(params).then((res) => {
        let newList = res.list;
        if (newList.length > 0) {
          this.styleLabelOne = newList.filter((v) => v.levelnum == "一级");
          this.styleLabelTwo = newList.filter((v) => v.levelnum == "二级");
          this.styleLabelThree = newList.filter((v) => v.levelnum == "三级");
        }
      });
    },

     // 一级功能标签
    getShopFunList() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getShopFunList(params).then((res) => {
        let subFilterList = res.list.filter((v) => v.labelstatestr == "启用");
        this.cmLevel1 = subFilterList.sort((a, b) => a.sort - b.sort);
      });
    },
    // 二级功能标签
    getShopFunChildList() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        parentid: this.formData.funcids_num1,
      };
      getShopFunChildList(params).then((res) => {
        let subFilterList = res.list.filter((v) => v.labelstatestr == "启用");
        this.cmLevel2 = subFilterList.sort((a, b) => a.sort - b.sort);
      });
    },
     // 触发一级功能标签
    handleRadioFuncid(e) {
      this.formData.funcids_num1 = e
      this.getShopFunChildList()
    },

    // 获得焦点
    inputFocus(e) {
      this.scrollTop = "-" + (e.srcElement.getBoundingClientRect().top - 200);
      this.isShowStyle = true;
    },
    // 失去焦点
    inputBlur() {
      this.isShowStyle = false;
    },
    handleNavBar(id) {
      if (id == 1) {
        window.location.replace("default.html");
      } else {
        this.$toast("即将开放");
      }
    },
    handleReturn() {
      history.back();
    },

    query() {
      let { formData, check2, checkStyleOne, checkStyleTwo, checkStyleThree } =
        this;
      // if (check2.length == 0) {
      //   this.$toast("请选择关键标签");
      //   return;
      // }
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      formData.labels = check2.join(",");
      formData.styleids_num1 = checkStyleOne.join(",");
      formData.styleids_num2 = checkStyleTwo.join(",");
      formData.styleids_num3 = checkStyleThree.join(",");
      // formData.labels = check1.join(",");
      // formData.labels2 = check2.join(",");
      // formData.labels3 = check3.join(",");
      // formData.labels4 = check4.join(",");
      editCommidity(formData).then((res) => {
        let data = res;
        if (data.result) {
          setTimeout(() => {
            Toast.clear();
            this.$toast.success(data.message);
          }, 500);
          // setTimeout(() => {
          //   history.back();
          // }, 1500);
        } else {
          this.$toast.fail(data.message || "服务器报错，请稍后～");
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.goodsManageSet {
  padding-bottom: 420px;
  .breadcrumb {
    padding-bottom: 20px;
  }
  .main_content {
    margin-bottom: 80px;
    .form_container {
      margin-top: 25px;
      .content_wrap {
        align-items: flex-start;
        p {
          margin-bottom: 8px;
          font-size: 24px;
          color: #6e6e6e;
        }
        .check_box {
          margin-bottom: 30px;
          /deep/ .el-checkbox {
            margin-bottom: 8px;
          }
        }
      }
    }
    // .content_wrap {
    //   margin-top: 70px;
    // }
    .tit {
      text-align: center;
      font-size: 32px;
      font-weight: bold;
      margin-bottom: 50px;
    }
    .check_box {
      /deep/ .van-checkbox {
        margin-bottom: 10px;
      }
    }
    h1 {
      text-align: center;
      font-weight: 400;
      margin-bottom: 20px;
      font-size: 30px;
    }
    p {
      font-size: 22px;
      margin-bottom: 20px;
      line-height: 30px;
      text-align: center;
    }
    // .block {
    //   margin-bottom: 80px;
    //   .check_box {
    //     /deep/ .van-checkbox {
    //       margin-bottom: 10px;
    //     }
    //   }
    //   h1 {
    //     text-align: center;
    //     font-weight: 400;
    //     margin-bottom: 20px;
    //     font-size: 30px;
    //   }
    //   p {
    //     font-size: 22px;
    //     margin-bottom: 20px;
    //     line-height: 30px;
    //     text-align: center;
    //   }
    // }
  }
}
</style>